import NotificationService from '../../common/api/notification.service';

export async function getAllNotifications({ commit }) {
  const response = await NotificationService.getAllNotifications();
  if (response.status === 200) {
    commit('setAll', { all: response.data.data });
  }
}

export async function listNotificationTopics({ commit }) {
  const response = await NotificationService.listNotificationTopics();
  if (response.status === 200) {
    commit('setAllTopics', { all: response.data });
  }
}

export async function createNotificationTopic({ dispatch }, { data }) {
  const response = await NotificationService.createNotificationTopic({ data });
  if (response.status === 201) {
    dispatch('listNotificationTopics');
  }
}

export async function updateNotificationTopic({ dispatch }, { id, data }) {
  const response = await NotificationService.updateNotificationTopic({ id, data });
  if (response.status === 303) {
    dispatch('listNotificationTopics');
  }
}

export async function deleteNotificationTopic({ dispatch }, { id }) {
  const response = await NotificationService.deleteNotificationTopic({ id });
  if (response.status === 204) {
    dispatch('listNotificationTopics');
  }
}

export async function sendNotification(context, { data }) {
  await NotificationService.sendNotification({ data });
}

export async function deleteNotificationMessage({ dispatch }, { id }) {
  const response = await NotificationService.deleteNotificationMessage({ id });
  if (response.status === 204) {
    dispatch('getAllNotifications');
  }
}
